import React ,{useState,useMemo}from "react";
import { Modal,Button,Transfer,SearchBox,Table } from "tea-component";
import "@/pages/home/assets/scss/page/home/components/customizeHomepage.scss"

const { selectable, removeable, scrollable } = Table.addons;

const cvmList = Array(1000)
  .fill(null)
  .map((_, i) => ({
    instanceId: `ins-${i}`,
    instanceName: `name-${i}`,
    status: "running",
  }));

const columns = [
  {
    key: "instanceName",
    header: "名称",
  },
];

export default function CustomizeHomepage(props:any){
        let {visible, close} = props
        const [targetKeys, setTargetKeys] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const targetKeySet = useMemo(() => new Set(targetKeys), [targetKeys]);
        return <Modal visible={visible} size={800} caption="Customize Homepage" onClose={close}>
        <Modal.Body>
        <Transfer
        className="customize-homepage"
      leftCell={
        <Transfer.Cell
          scrollable={false}
          title="ADD A CARD"
          tip="Shift holding is supported for multiple selection"
          header={
            <SearchBox
              value={inputValue}
              placeholder="搜索"
              onChange={value => setInputValue(value)}
            />
          }
        >
          <SourceTable
            dataSource={cvmList.filter(
              i =>
                i.instanceId.includes(inputValue) ||
                i.instanceName.includes(inputValue)
            )}
            targetKeys={targetKeys}
            onChange={(keys:any) => setTargetKeys(keys)}
          />
        </Transfer.Cell>
      }
      rightCell={
        <Transfer.Cell
          scrollable={false}
          title={`Selected (${targetKeys.length})`}
        >
          <TargetTable
            dataSource={cvmList.filter(i => targetKeySet.has(i.instanceId))}
            onRemove={(key:any) => setTargetKeys(targetKeys.filter(i => i !== key))}
          />
        </Transfer.Cell>
      }
    />

        </Modal.Body>
        <Modal.Footer>
          <Button type="primary" onClick={close}>
            确定
          </Button>
          <Button type="weak" onClick={close}>
            取消
          </Button>
        </Modal.Footer>
      </Modal>
} 

function SourceTable({ dataSource, targetKeys, onChange }:any) {
    return (
      <Table
        className="source-table"
        records={dataSource}
        recordKey="instanceId"
        columns={columns}
        addons={[
          scrollable({
            virtualizedOptions: {
              height: 310,
              itemHeight: 55,
              onScrollBottom: () => console.log("Bottom"),
            },
          }),
          selectable({
            value: targetKeys,
            onChange,
            rowSelect: true,
          }),
        ]}
      />
    );
  }
  
  function TargetTable({ dataSource, onRemove }:any) {
    return (
      <Table
        className="target-table"
        records={dataSource}
        recordKey="instanceId"
        columns={columns}
        addons={[
          scrollable({
            virtualizedOptions: {
              height: 340,
              itemHeight: 55,
            },
          }),
          removeable({ onRemove }),
        ]}
      />
    );
  }